import React from "react";
import { FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const HighlightButton = (props) => {
  const { text, to, email, onclick, disabled } = props;
  return (
    <Link to={to} state={{ email: email ? email : "" }}>
      <button
        onClick={onclick}
        disabled={disabled}
        style={props.style}
        className="group bg-[#9B8AFB] text-black text-base font-semibold py-2 pl-6 pr-3 md:py-3 
          flex gap-2 items-center justify-center rounded-[24px] border border-[#DCDFEA]"
      >
        <p>{text}</p>
        {props.noArrow ? null : <FaChevronRight
          color="#000"
          className="invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity duration-300"
        />}
      </button>
    </Link>
  );
};

export default HighlightButton;
